import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgC2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 27)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(7 2)",
				fill: "#1D1D1B",
				fillRule: "nonzero",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: 44,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 39,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 5,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						width: 2,
						height: 22,
						rx: .9
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.51 9.463a1.93 1.93 0 00-.55-1.23 1.74 1.74 0 00-1.29-.48 2.06 2.06 0 00-1.65.76 3.12 3.12 0 00-.45.78 6.32 6.32 0 00-.28.93 8 8 0 00-.15 1c0 .32-.06.62-.08.89a2.72 2.72 0 011.15-1.13 3.49 3.49 0 011.57-.37 4.06 4.06 0 011.68.33 3.65 3.65 0 011.25.89c.352.388.62.844.79 1.34a5.1 5.1 0 01.27 1.68 4.71 4.71 0 01-.3 1.7 3.89 3.89 0 01-.86 1.37c-.37.399-.824.71-1.33.91a4.34 4.34 0 01-1.71.33 4.53 4.53 0 01-2.28-.51 3.89 3.89 0 01-1.38-1.42 6.21 6.21 0 01-.71-2.09 16.12 16.12 0 01-.2-2.59 10.57 10.57 0 01.25-2.32c.15-.74.42-1.449.8-2.1a4.61 4.61 0 011.47-1.54 4 4 0 012.24-.59 3.89 3.89 0 011.42.23 3.93 3.93 0 011.19.7c.344.303.626.67.83 1.08.224.437.348.919.36 1.41l-2.05.04zm-2 8a2.06 2.06 0 001.69-.81 2.37 2.37 0 00.42-.84 3.62 3.62 0 00.13-1 3.51 3.51 0 00-.13-1 2.36 2.36 0 00-.42-.82 2 2 0 00-1.67-.76 2.36 2.36 0 00-1 .2 2.18 2.18 0 00-.71.56 2.57 2.57 0 00-.43.82 3.61 3.61 0 000 2c.093.3.238.581.43.83a2 2 0 00.71.59 2.22 2.22 0 001 .2l-.02.03z",
				fill: "#1D1D1B",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: -1,
				y: -1,
				width: 62,
				height: 28,
				rx: 2
			})
		]
	})
});
export default SvgC2;
